




import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import HlsPlayer from 'xgplayer-hls.js';
import Mp4Player from 'xgplayer';
@Component
export default class XGplayer extends Vue {
  @Prop({
    default: '',
  })
  videoUrl!: string;
  @Prop({
    default: '',
  })
  videoCover?: string;
  @Prop({ default: false }) fillScreen!: boolean; // 是否以平铺短视频形式展示

  player: any = null;

  @Watch('videoUrl')
  onVideoUrlChange() {
    if (this.player) {
      this.player.destroy();
    }
    this.setUpPlayer();
  }

  mounted() {
    this.setUpPlayer();
  }

  setUpPlayer() {
    const ua = window.navigator.userAgent;
    const regWeiXin = /MicroMessenger/g;
    const isWeiXin = regWeiXin.test(ua);
    const IsiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

    const util = HlsPlayer.util;
    const playerDefaultSize = {
      height: 350,
      width: 300,
    };

    // 判断视频格式
    if (/.m3u8/.test(this.videoUrl)) {
      this.player = new HlsPlayer({
        el: this.$refs.myXgPlayer,
        url: this.videoUrl,
        poster: this.videoCover,
        fluid: !this.fillScreen,
        height: this.fillScreen ? window.innerHeight : playerDefaultSize.height,
        width: this.fillScreen ? window.innerWidth : playerDefaultSize.width,
        playsinline: IsiOS,
        'x5-video-player-type': 'h5-page',
        'x5-video-player-fullscreen': true,
        closeVideoTouch: true,
        lang: 'zh-cn',
        ignores: ['volume'],
      });
    } else {
      this.player = new Mp4Player({
        el: this.$refs.myXgPlayer as HTMLDivElement,
        url: this.videoUrl,
        poster: this.videoCover,
        fluid: !this.fillScreen,
        height: this.fillScreen ? window.innerHeight : playerDefaultSize.height,
        width: this.fillScreen ? window.innerWidth : playerDefaultSize.width,
        playsinline: IsiOS,
        'x5-video-player-type': 'h5',
        'x5-video-player-fullscreen': true,
        closeVideoTouch: true,
        lang: 'zh-cn',
        ignores: ['volume'],
      });
    }

    // this.player.start(this.videoUrl);

    // ? 微信里仅支持timeupdate才能正确获取视频duration，但该周期在其它环境无效。反之canplay在微信环境无效。
    if (isWeiXin) {
      this.player.once('timeupdate', () => {
        setTimeout(() => {
          console.log('timeupdate', this.player.duration);
          if (this.player.duration === Infinity) {
            util.addClass(this.player.root, 'xgplayer-is-live');
            const live = util.createDom(
              'xg-live',
              '正在直播',
              {},
              'xgplayer-live',
            );
            this.player.controls.appendChild(live);
          }
        }, 500);
      });
    } else {
      this.player.once('canplay', () => {
        setTimeout(() => {
          console.log('canplay', this.player.duration);
          if (this.player.duration === Infinity) {
            util.addClass(this.player.root, 'xgplayer-is-live');
            const live = util.createDom(
              'xg-live',
              '正在直播',
              {},
              'xgplayer-live',
            );
            this.player.controls.appendChild(live);
          }
        }, 500);
      });
    }
    this.player.on('play', () => {
      this.$emit('playing');
    });
    this.player.on('ended', () => {
      this.$emit('ended');
    });
  }
  beforeDestroy() {
    this.player.destroy();
    this.player = null;
  }
}
